<template>
  <table class="table  border-bottom fs-5 w-100">
    <thead class="">
      <tr class="">
        <!-- <th class="fs-5" style="width: 20px;">#</th> -->
        <th class="fw-bold pl-5">Date In</th>
        <th class="fw-bold ">Date Out</th>
        <th class="fw-bold " style="width: 80px;" >Days</th>
        <th class="fw-bold ">Rate</th>
        <th class="fw-bold ">
          <!-- <button class="btn btn-sm" @click="addCrReleaseLine"><i class="fa fa-plus text-success" ></i></button> -->
        </th>
      </tr>
    </thead>
    <tbody v-if="cr_releases?.length > 0">
      <tr v-for="(cr, i) in cr_releases" :key="i" class="fs-6">
        <!-- <td style="width: 20">{{i+1}}</td> -->
        <td class="p-1 pl-5">
          <input
            type="date"
            class=" form-control-lg w-100"
            placeholder=""
            @change="dateInChange(i)"
            v-model="cr_releases[i].dateIn"
          />
        </td>
        <td class="p-1 ">
          <input
            type="date"
            class=" form-control-lg w-100"
            placeholder=""
            @change="dateOutChange(i)"
            v-model="cr_releases[i].dateOut"
          />
        </td>
        <td class="p-1 ">
          <input
            readonly
            type="number"
            class=" form-control-lg " style="width: 80px;"
            placeholder=""
            v-model="cr_releases[i].actualDays"
            :key="cr_releases[i].actualDays"
            @change="actualDaysChange"
          />
        </td>
        <td class="p-1 " >
          <select
            class="mt-0  form-control-lg w-100"
             style="min-width: 65px;"
            v-model="cr_releases[i].creditRatio"
            @change="dateDiffCalcNow"
          >
            <option :value="2 / 3">66%</option>
            <option :value="0.5">50%</option>
            <option :value="1 / 3">33%</option>
            <option :value="0.2">20%</option>
            <option :value="0.15">15%</option>
            <option :value="0">0%</option>
          </select>
        </td>
        <td class="td-with-button border-0 ">
          <button class="btn btn-primary-outline " style="width: 50px;" v-if="i !== cr_releases.length - 1"  @click="removeCrReleaseLine(i)">
            <i class="fa fa-trash"></i>
          </button>
          <button class="btn btn-primary " style="width: 50px;" v-else  @click="addCrReleaseLine()">
            <i class="fa fa-plus"></i>
          </button>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import axios from "axios";
import moment from "moment";
import SC from "../../../components/utils/sharedComponent.vue";

export default {
  name: "CreditRelease",

  props: ["cr_release_data"],

  data() {
    return {
      dt: moment,
      cr_release: [],
      cr_releases: [],
    };
  },

  methods: {
    addCrReleaseLine() {
      let cr_release = {
        dateIn: "",
        dateOut: "",
        // dateIn - dateOut
        actualDays: 0,
        // conduct (value will be calculated by the FORMULA  100 * (1 - 1 / 1.15);)
        conduct: 0,
        //creditRatioId which points to the ratio in CreditRatios table
        creditRatio: 0,
        date_out_disabled: true,
      };

      //let cr_release =  JSON.parse(JSON.stringify(this.cr_release));
      if (this.cr_releases == null) {
        this.cr_releases = [];
        this.cr_releases.push(cr_release);
      } else this.cr_releases.push(cr_release);

      // console.log("added:::>", this.cr_releases);
    },

    removeCrReleaseLine(i) {
      // if (i > 0) {
        this.cr_releases.splice(i, 1);
        // console.log("removed:::>", this.cr_releases);
        this.dateDiffCalcNow();
        
      // } else {
      //   this.cr_releases[i].dateIn = null;
      //   this.cr_releases[i].dateOut = null;
      //   this.cr_releases[i].date_out_disabled = true;
      //   this.cr_releases[i].actualDays = 0;
      // }
      this.$emit("updateCredits", {
    
        crData: this.cr_releases,
      });
    },

    actualDaysChange() {
      // console.log("changed:::>", this.cr_releases);
    },

    dateDiffCalcNow() {
      var actualDaysTotal = 0;

      this.cr_releases.forEach((cr) => {
        if (cr.actualDays != 0) {
          if (cr.dateOut != "") actualDaysTotal += cr.actualDays;
          // console.log("cr.actualDays => ... ", cr.actualDays);
        }
      });

      this.$emit("updateCredits", {
        actualDaysTotal,
        crData: this.cr_releases,
      });
    },

    dateDiffCalc(i) {
      let actualDays = 0;

      let dateIn = this.dt(this.cr_releases[i].dateIn);
      let dateOut = this.dt(this.cr_releases[i].dateOut);

      // console.log(dateIn);
      // console.log(dateOut);

      actualDays = dateOut.diff(dateIn, "days") + 1;
      this.cr_releases[i].actualDays = actualDays;

      // console.log("actualDays:::>", actualDays);

      let arrCount = this.cr_releases.length;

      // console.log(
      //   "this.cr_releases[arrCount-1].actualDays",
      //   this.cr_releases[arrCount - 1].actualDays,
      //   this.cr_releases[arrCount - 1].dateOut
      // );
      if (
        this.cr_releases[arrCount - 1].actualDays != 0 &&
        this.cr_releases[arrCount - 1].dateOut != ""
      )
        // this.addCrReleaseLine();

      this.dateDiffCalcNow();
    },

    dateInChange(i) {
      this.cr_releases[i].date_out_disabled = false;
      if (SC.isCZ(this.cr_releases[i].dateOut) == true)
        this.cr_releases[i].dateOut = this.dt.utc(this.dt.moment).format("YYYY-MM-DD");

      this.dateDiffCalc(i);
    },

    dateOutChange(i) {
      if (this.cr_releases[i]?.dateIn !== "") {
        this.dateDiffCalc(i);
      }
    },
  },

  beforeMount() {
    // console.log(this.cr_release_data?.crData);
    this.cr_releases = this.cr_release_data?.crData;
    
    if (!this.cr_releases || this.cr_releases?.length === 0) {
      // console.log("addCrReleaseLine");
        this.addCrReleaseLine();
      }

    // console.log("CreditRelease mounted:::>", this.cr_releases);

    // console.log('cr_release_data::>>>', this.cr_release_data.crData.crData, this.cr_release_data.crData.crData.length);
  },
};
</script>

<style lang="scss" scoped>

.form-control-lg {
  font-size: 1rem !important;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  /* display: none; <- Crashes Chrome on hover */
  -webkit-appearance: none;
  margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
}

input[type="number"] {
  -moz-appearance: textfield; /* Firefox */
}
</style>
